import moment from 'moment';

const FROM_TIMEZONE: string = (() => {
    const storage = localStorage.getItem('token-hash');
    if (storage) {
        const token = JSON.parse(storage);
        if (token.timezone) return token.timezone;
    }
    return '';
})();

const TO_TIMEZONE = Intl.DateTimeFormat().resolvedOptions().timeZone;

export const convertTimezone = (dateString: string): string => {
    try {
        if (!dateString || !FROM_TIMEZONE || !TO_TIMEZONE || FROM_TIMEZONE === TO_TIMEZONE) {
            return dateString;
        }

        const inputFormat = 'DD/MM/YYYY HH:mm:ss';

        const momentDate = moment.tz(dateString, inputFormat, FROM_TIMEZONE);
        const isAlreadyInTarget = momentDate.tz(TO_TIMEZONE).format(inputFormat) === dateString;
        if (isAlreadyInTarget) {
            return dateString;
        }

        const convertedDate = momentDate.tz(TO_TIMEZONE);

        return convertedDate.format(inputFormat);
    } catch (error) {
        console.error('Erro ao converter timezone:', error);
        return dateString;
    }
};
